import {
  createSlice,
  PayloadAction
} from "@reduxjs/toolkit";
import { UserField } from "../../constants/userField";

type SortType = {
  field: UserField,
  format: "ASC" | "DESC"
}

export const initialAdminState = {
  sortAdminTable: {
    field: UserField.login,
    format: 'ASC',
  } as SortType,
  showDelete: false
}

const adminSlice = createSlice({
  name: "adminSlice",
  initialState: initialAdminState,
  reducers: {
    changeSortAdmin: (state, action: PayloadAction<UserField>) => {
      if (state.sortAdminTable.field === action.payload) {
        if (state.sortAdminTable.format === "ASC") {
          state.sortAdminTable.format = "DESC";
        } else {
          state.sortAdminTable.format = "ASC";
        }
      } else {
        state.sortAdminTable.field = action.payload;
        state.sortAdminTable.format = "DESC";
      }
    },
    setShowDelete: (state, action: PayloadAction<boolean>) => {
      state.showDelete = action.payload;
    },
  }
});

export const {
  changeSortAdmin,
  setShowDelete
} = adminSlice.actions;

export default adminSlice.reducer;